import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import Navbar from "react-bootstrap/Navbar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logoImg from "../../../assets/brand/pmp_medical_logo.svg";
import { useAuth } from "../context/AuthContext.jsx";
import CatalogSearch from "./CatalogSearch.jsx";

const navItems = [
  { label: "Home", to: "/" },
  { label: "Catalog", to: "/catalog" },
  { label: "About", to: "/about" },
  { label: "Contacts", to: "/contacts" },
];

export default function SiteNavbar({ site }) {
  const brand = site?.brand ?? "PMP";
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  function handleLogout() {
    logout();
    navigate("/");
  }

  // Catalog stays lit across the whole catalog section (item pages + search);
  // Home only on the exact root; the rest match their own path/subtree.
  function isNavActive(to) {
    if (to === "/") return pathname === "/";
    if (to === "/catalog") {
      return (
        pathname === "/catalog" ||
        pathname.startsWith("/catalog/") ||
        pathname.startsWith("/search")
      );
    }
    return pathname === to || pathname.startsWith(`${to}/`);
  }

  return (
    <Navbar expand="lg" sticky="top" className="pmp-navbar">
      <Container>
        <Navbar.Brand
          as={Link}
          to="/"
          className="pmp-brand d-flex align-items-center py-1 me-auto"
        >
          <img
            src={logoImg}
            alt={`${brand} — Medical`}
            className="pmp-brand-logo"
          />
        </Navbar.Brand>

        <CatalogSearch />

        <Navbar.Toggle aria-controls="pmp-nav" />

        <Navbar.Collapse id="pmp-nav">
          <Nav className="align-items-lg-center">
            {navItems.map((item) => (
              <Nav.Link
                key={`${item.label}-${item.to}`}
                as={Link}
                to={item.to}
                active={isNavActive(item.to)}
              >
                {item.label}
              </Nav.Link>
            ))}

            {user ? (
              <NavDropdown
                title={user.name}
                id="pmp-user-menu"
                align="end"
                menuVariant="dark"
              >
                <NavDropdown.Item as={Link} to="/profile">
                  My Profile
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={handleLogout}>
                  Sign Out
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Nav.Link as={Link} to="/login" className="pmp-nav-signin">
                Sign In
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
